import React from 'react';

const iOS = () => {
    return (
        <>
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb_box text-center">
                                <h2 className="breadcrumb-title">Native iOS Development</h2>
                                <ul className="breadcrumb-list">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/technologies">Technologies</a></li>
                                    <li className="breadcrumb-item active">iOS</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-wrapper section-space--ptb_100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="content-area">
                                <div className="service-details-content">
                                    <h1>Premium Native iOS Development</h1>
                                    
                                    <p className="lead">We develop native iOS applications using Swift and Objective-C. Our applications deliver exceptional performance, security, and user experience on Apple devices, supporting iPhone, iPad, and other iOS platforms.</p>

                                    <h3 className="mt-50">Native Excellence on Apple Platforms</h3>
                                    <p>Native iOS development provides maximum performance and access to all Apple-specific features. Our Swift expertise ensures modern, clean code that leverages iOS frameworks optimally.</p>

                                    <h3 className="mt-40">Complete iOS Feature Set</h3>
                                    <ul>
                                        <li><strong>Native Performance:</strong> Direct hardware access for optimal speed</li>
                                        <li><strong>Access to All iOS APIs:</strong> Full capability of the iOS platform</li>
                                        <li><strong>Seamless Integration with Apple Ecosystem:</strong> iCloud, Apple Pay, Siri</li>
                                        <li><strong>Secure & Privacy-Focused:</strong> Built-in security features and privacy controls</li>
                                        <li><strong>SwiftUI Support:</strong> Modern declarative UI framework</li>
                                        <li><strong>Advanced Graphics & Animation:</strong> Metal and SceneKit for graphics</li>
                                        <li><strong>HomeKit & Watch Integration:</strong> IoT and wearable support</li>
                                        <li><strong>App Store Excellence:</strong> Optimized for App Store distribution</li>
                                    </ul>

                                    <h3 className="mt-40">Premium iOS Applications</h3>
                                    <p><strong>Financial Apps:</strong> Banking and investment apps requiring maximum security.</p>
                                    <p><strong>Creative Tools:</strong> Image editors, music apps leveraging advanced graphics.</p>
                                    <p><strong>Enterprise Apps:</strong> Complex business applications with iOS-specific optimizations.</p>

                                    <h3 className="mt-40">AppCore's iOS Excellence</h3>
                                    <div className="case-study-box mt-30">
                                        <h5>Success: Premium Fintech iOS App</h5>
                                        <p>We developed a financial app with iOS-native excellence:</p>
                                        <ul>
                                            <li>🔐 Bank-level security & encryption</li>
                                            <li>⚡ Native performance with zero lag</li>
                                            <li>🎨 Beautiful SwiftUI interface</li>
                                            <li>📊 App Store rating: 4.8/5 stars</li>
                                        </ul>
                                    </div>

                                    <h3 className="mt-40">Swift Development Expertise</h3>
                                    <ul>
                                        <li>SwiftUI for modern UI development</li>
                                        <li>Combine framework for reactive programming</li>
                                        <li>Core Data for local persistence</li>
                                        <li>CloudKit for iCloud synchronization</li>
                                        <li>Network optimization and API integration</li>
                                        <li>Unit & UI testing with XCTest</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar-area">
                                <div className="sidebar-widget mb-50">
                                    <h5 className="widget-title mb-30">iOS Capabilities</h5>
                                    <ul className="sidebar-list">
                                        <li>🚀 Native Performance</li>
                                        <li>🔒 Bank-Grade Security</li>
                                        <li>🎨 SwiftUI Framework</li>
                                        <li>📱 iPhone & iPad</li>
                                        <li>⌚ Apple Watch Integration</li>
                                        <li>🏠 HomeKit Support</li>
                                    </ul>
                                </div>

                                <div className="sidebar-widget">
                                    <h5 className="widget-title mb-30">Project Excellence</h5>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">iOS Apps Shipped</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>40+</p>
                                    </div>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Avg App Rating</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>4.8/5</p>
                                    </div>
                                    <div className="metric-item">
                                        <p className="metric-label">Crash-Free Rate</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>99.9%</p>
                                    </div>
                                </div>

                                <div className="sidebar-widget mt-50">
                                    <h5 className="widget-title mb-30">Apple Platform Leaders</h5>
                                    <p className="small">Our iOS expertise spans financial services, healthcare, entertainment, and enterprise applications meeting Apple's highest standards.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default iOS;
